export const SHIPMENT_TOAST_MESSAGES = {
	addressSaved: "Address saved",
	addressUpdated: "Address updated",
	remarkUpdated: "Remark updated",
	checkCallUpdated: "Check call updated",
	shipmentChangesSaved: "Shipment changes saved",
	shipmentForceUnlocked: "Shipment unlocked",
	claimSaved: "Success! Claim has been saved",
	shipmentUnmarkedLoaded: "Shipment has been Unmarked Loaded",
	shipmentMarkedLoaded: "Shipment has been Marked Loaded",
	shipmentMarkedDelivered: "Shipment has been Marked Delivered",
	shipmentUnmarkedDelivered: "Shipment has been Unmarked Delivered",
} as const;
